module.exports = __webpack_public_path__ + "img/1.1bc30ae0.jpg";